import logo from "../assets/images/logo.svg";

import logoWhite from "../assets/images/logowhite.svg";
import foodWaterIcon from "../assets/images/food_water.svg";
import environmentIcon from "../assets/images/environment.svg";
import buildRepearIcon from "../assets/images/build_repair.svg";
import educationIcon from "../assets/images/education.svg";
import impact from "../assets/images/impactB.png";
import aboutUs from "../assets/images/aboutus.png";
import missionA from "../assets/images/missionA.png";
import missionB from "../assets/images/missionB.png";
import logoA from "../assets/images/logoA.svg";
import logoB from "../assets/images/logoB.svg";
import logoC from "../assets/images/logoC.svg";
import logoD from "../assets/images/logoD.svg";
import logoE from "../assets/images/logoE.svg";
import blogA from "../assets/images/blogA.png";
import blogB from "../assets/images/blogB.png";
import blogC from "../assets/images/blogC.png";
import workA from "../assets/images/workA.png";
import workB from "../assets/images/workB.png";
import workC from "../assets/images/workC.png";
import workD from "../assets/images/workD.png";
import workE from "../assets/images/workE.png";
import workF from "../assets/images/workF.png";
import footerLogo from "../assets/images/footerLogo.svg";
import triPattern from "../assets/images/threePattern.png";
import programA from "../assets/images/programA.png";
import programB from "../assets/images/programB.png";
import programC from "../assets/images/programC.png";
import fatherSon from "../assets/images/fatherson.png";
import bgLogo from "../assets/images/bgLogo.png";
import colorLogo from "../assets/images/colorLogo.svg";
import story from "../assets/images/story.jpg";

export const images = {
  logo,
  bgLogo,
  logoWhite,
  colorLogo,
  footerLogo,
  foodWaterIcon,
  environmentIcon,
  buildRepearIcon,
  educationIcon,
  impact,
  aboutUs,
  missionA,
  missionB,
  logoA,
  logoB,
  logoC,
  logoD,
  logoE,
  blogA,
  blogB,
  blogC,
  workA,
  workB,
  workC,
  workD,
  workE,
  workF,
  triPattern,
  programA,
  programB,
  programC,
  fatherSon,
  story,
};
